import {connect} from 'react-redux';
import {map, compact, values, kebabCase, includes, concat} from 'lodash';
import {bindActionCreators} from 'redux';
import {isFafsaItem} from 'shared/college-success/actions/fafsa';
import PortfolioList from 'shared/college-success/components/portfolio-list';
import {deleteFafsaSubmission} from 'shared/college-success/actions/fafsa';
import {removePerfectAttendance} from 'shared/college-success/actions/perfect-attendance';
import {deleteCollegeEvent} from 'shared/college-success/actions/college-events';
import {deleteTimeSensitiveItem} from 'shared/college-success/actions/time-sensitive-item';
import {consolidateSchoolYears, MONTH_ABBRVS} from 'shared/utils';
import {SHARED_COLLEGE_EVENTS} from 'shared/components/form-inputs/college-event';

const mapStateToProps = ({
  student: {fafsaSubmission},
  attendance,
  collegeEvents,
  collegeSuccessItems,
}) => ({
  fafsaSubmissions: fafsaSubmission && fafsaSubmission.submittedAtYear ? [fafsaSubmission] : [],
  attendance: compact(
    map(attendance, (absences, year) => {
      if (absences === 0) return year;
    })
  ),
  collegeEvents: values(collegeEvents),
  collegeSuccessItems: values(collegeSuccessItems),
});

const mapDispatchToProps = (dispatch) => ({
  deleteTimeSensitiveItem: (id) => () => dispatch(deleteTimeSensitiveItem(id)),
  deleteCollegeEvent: (id) => () => dispatch(deleteCollegeEvent(id)),
  deleteFafsaSubmission: (id) => () => dispatch(deleteFafsaSubmission(id)),
  ...bindActionCreators(
    {
      removePerfectAttendance,
    },
    dispatch
  ),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const handleCollegeSuccessRemove = (item) => {
    switch (item._type) {
      case 'FafsaSubmissionItem':
        return dispatchProps.deleteFafsaSubmission(item._id);
      default:
        return dispatchProps.deleteTimeSensitiveItem(item._id);
    }
  };

  const portfolioItems = concat(
    formatCollegeSuccessItems(stateProps.collegeSuccessItems, handleCollegeSuccessRemove),
    formatPerfectAttendance(stateProps.attendance, dispatchProps.removePerfectAttendance),
    formatCollegeEvents(stateProps.collegeEvents, dispatchProps.deleteCollegeEvent)
  );

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    portfolioItems,
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(PortfolioList);

// Formatting helpers
const formatCollegeEvents = (events, handleRemove) =>
  map(events, ({_id, collegeName, month, name, year}) => {
    const eventName = includes(SHARED_COLLEGE_EVENTS, name) ? `/${kebabCase(name)}` : '';
    return {
      subtitle: `${MONTH_ABBRVS[month]} ${year} • ${collegeName}`,
      name,
      handleRemove: handleRemove(_id),
      editLink: `/college-success/college-event${eventName}/form/${_id}`,
    };
  });

const formatPerfectAttendance = (attendance, handleRemove) =>
  attendance.length > 0
    ? {
        subtitle: consolidateSchoolYears(attendance).join(', '),
        name: 'Perfect Attendance',
        handleRemove,
        editLink: '/college-success/perfect-attendance/form',
      }
    : [];

const getFafsaEditLink = (item) => `/college-success/fafsa/form/${item._id}`;
const getTimeSensitiveEditLink = (item) =>
  `/college-success/time-sensitive/${item.timeSensitiveItemTypeId}/form/${item._id}`;

const formatCollegeSuccessItems = (items, handleRemove) =>
  map(items, (item) => {
    const isFafsa = isFafsaItem(item);
    const editLink = isFafsa ? getFafsaEditLink : getTimeSensitiveEditLink;
    return {
      subtitle: (COLLEGE_SUCCESS_ITEM_TO_SUBTITLE[item._type] || defaultItemToSubtitle)(item),
      name: item.title,
      handleRemove: handleRemove(item),
      editLink: editLink(item),
    };
  });

const defaultItemToSubtitle = ({completedAtMonth, completedAtYear}) =>
  `${MONTH_ABBRVS[completedAtMonth]} ${completedAtYear}`;

const COLLEGE_SUCCESS_ITEM_TO_SUBTITLE = {
  FafsaSubmissionItem: ({submittedAtMonth, submittedAtYear}) =>
    `${MONTH_ABBRVS[submittedAtMonth]} ${submittedAtYear}`,
};
